import React from 'react';

import { Returns } from '~/screens/Contract/components/Tabs/Returns/Returns';
import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type CardReturnsViewProps = {
  contractId: string;
  contract: any;
  onBack: () => void;
};

export function CardReturnsView({ contractId, contract, onBack }: CardReturnsViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <Returns contract={contract} />
    </div>
  );
}
